<template>
    <div class="adTemp">
        <el-form ref="form" :rules="rules" :model="form" label-width="90px">
            <el-form-item label="广告名称: " prop="title">
                <el-input class="input-el" v-model="form.title"></el-input>
            </el-form-item>
            <p class="tips">广告名称只是作为辨别多个广告条目之用，并不显示在广告中</p>
            <el-form-item label="广告位置: " prop="adType">
                <el-select v-model="form.adType" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上线/下线: " prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">上线</el-radio>
                    <el-radio :label="2">下线</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="广告图片: " prop="fileName" ref="fileName">
                <el-upload
                    :accept="accept"
                    align="center"
                    class="upload"
                    :action="uploadAction"
                    :headers="headers"
                    :on-success="upImgsSuccess"
                    :file-list="imagesList"
                    list-type="picture"
                    :before-upload="beforeUpload"
                    :on-remove="imgsRemove"
                    :limit="1"
                    :on-exceed="handleExceed"
                >
                    <i class="el-icon-upload"></i>
                    <span>选择上传文件</span>
                </el-upload>
            </el-form-item>
            <p class="tips">只能上传jpg/png格式文件，文件不能超过1MB</p>
            <el-form-item label="广告链接: " prop="id">
                <el-input class="input-el" type="number" placeholder="请输入商品ID" v-model="form.id">
                    <template slot="prepend">{{picUrl}}</template>
                </el-input>
            </el-form-item>
            <el-form-item style="margin-left: -15%;" align="center">
                <el-button :loading="loading" @click="submit" type="primary">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: ['data', 'type'],
    data() {
        var hasImg = (rule, value, callback) => {
            if (this.form.fileName === '') {
                callback(new Error('请上传图片'));
            } else {
                callback();
            }
        };
        var isInt = (rule, value, callback) => {
            if (/^(([0-9]*[1-9][0-9]*)|(0))$/.test(value) || value === '') {
                callback();
            } else {
                callback(new Error("请输入正确的商品ID"));
            }
        };
        return {
            loading: false,
            rules: {
                title: { required: true, message: '请输入广告名称', trigger: 'change' },
                adType: { required: true, message: '请选择广告类型', trigger: 'change' },
                status: { required: true, message: '请选择广告状态', trigger: 'change' },
                fileName: { required: true, validator: hasImg, trigger: 'change' },
                link: { validator: isInt, trigger: 'change' }
            },
            picUrl: '../goods/goodsDetail/goodsDetail?itemID=',
            form: {
                title: '',
                adType: '',
                status: '',
                link: '',
                fileName: ''
            },
            options: [
                { value: 1, label: "首页轮播" },
                { value: 2, label: "积分兑换轮播" }
            ],
            accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            // headers: {
            //   'Authorization': sessionStorage.getItem('accessToken'),
            // }, //正式头部
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadImage',
            imagesList: [],
            baseUrl: this.$store.state.apiUrl,
        };
    },
    watch: {
        data(val) {
            this.form = val
            this.imagesList = []
            this.imagesList.push({
                name: val.fileName,
                url: this.baseUrl + val.imageUrl
            });
        },
        'form.adType'(val) {
            if (val == 2) {
                this.picUrl = '../../goods/pointGoods/pointGoods?itemID='
            } else {
                this.picUrl = '../goods/goodsDetail/goodsDetail?itemID='
            }
        }
    },
    computed: {},
    methods: {
        submit(formName) {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // console.log(this.form)
                    let data = Object.assign({}, this.form)
                    if (data.id) {
                        data.link = this.picUrl;
                    } else {
                        data.link = "";
                        data.id = ''
                    }
                    console.log(data.link);
                    data.idType = 1
                    this.$emit('sendData', data, this.type)
                } else {
                    console.log('error submit!!');
                    console.log(this.form)
                    return false;
                }
            });
        },
        upImgsSuccess(response, file, fileList) {
            this.form.fileName = response.result.fileName;
            this.imagesList.push({
                name: response.result.fileName,
                url: this.baseUrl + response.result.url
            });
            this.$refs.fileName.clearValidate()
        },
        imgsRemove(file, fileList) {
            let self = this;
            this.imagesList = fileList;
            this.form.fileName = ''
        },
        beforeUpload(file) {
            const isLt500k = file.size / 1024 < 1024;
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.$message.error('上传的图片只支持JPG/PNG 的格式!');
                return false;
            }
            if (!isLt500k) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt500k;
        },
        handleExceed() {
            this.$message.error('抱歉，最多上传一张图片！');
        }
    },
    created() { },
    mounted() { }
};
</script>
<style lang="scss" scoped>
.adTemp {
    .tips {
        margin: -10px 0 12px 16%;
        color: #999;
    }
    .upload {
        width: 150px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
    }
    .input-el {
        width: 450px;
    }
}
</style>